/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Features_Title8Inputs */

const en_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small features`)
};

const ar_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزايا صغيرة`)
};

const bn_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ছোট ফিচার`)
};

const de_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine Features`)
};

const es_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pequeñas funciones`)
};

const fr_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petites fonctionnalités`)
};

const pt_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pequenas features`)
};

const zh_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小功能`)
};

const tr_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küçük özellikler`)
};

const ru_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мелкие фичи`)
};

const pl_svc_retainer_features_title8 = /** @type {(inputs: Svc_Retainer_Features_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Małe funkcje`)
};

/**
* | output |
* | --- |
* | "Small features" |
*
* @param {Svc_Retainer_Features_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_features_title8 = /** @type {((inputs?: Svc_Retainer_Features_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Features_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_features_title8(inputs)
	if (locale === "bn") return bn_svc_retainer_features_title8(inputs)
	if (locale === "de") return de_svc_retainer_features_title8(inputs)
	if (locale === "es") return es_svc_retainer_features_title8(inputs)
	if (locale === "fr") return fr_svc_retainer_features_title8(inputs)
	if (locale === "pt") return pt_svc_retainer_features_title8(inputs)
	if (locale === "zh") return zh_svc_retainer_features_title8(inputs)
	if (locale === "tr") return tr_svc_retainer_features_title8(inputs)
	if (locale === "ru") return ru_svc_retainer_features_title8(inputs)
	if (locale === "pl") return pl_svc_retainer_features_title8(inputs)
	return en_svc_retainer_features_title8(inputs)
});
export { svc_retainer_features_title8 as "svc_retainer_FEATURES_title" }